/** @flow */
import * as React from 'react';
import { withRouter } from 'react-router-dom';

type Props = {
  children?: React.Element<any>;
  location: Object;
}

class ScrollToTop extends React.Component<Props, void> {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/common/layout/ScrollToTop.js